/**
 * Servizio centralizzato per le chiamate API
 * Configura axios con interceptor per aggiungere automaticamente il token di autenticazione
 */
import axios from 'axios';
import { getNodeApiUrl } from '../config/api.config';

// Crea un'istanza axios con configurazione di base
const apiClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
  }
});

// Interceptor per aggiungere il token di autenticazione a tutte le richieste
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('installamelo-auth-token');
    if (token) {
      config.headers['auth-token'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Effettua una chiamata GET a un endpoint API
 * @param {string} endpoint - Endpoint API (senza baseUrl)
 * @param {object} params - Parametri query string opzionali
 * @returns {Promise} - Promise con la risposta
 */
export const apiGet = (endpoint, params = {}) => {
  const url = getNodeApiUrl(endpoint);
  return apiClient.get(url, { params });
};

/**
 * Effettua una chiamata POST a un endpoint API
 * @param {string} endpoint - Endpoint API (senza baseUrl)
 * @param {object} data - Dati da inviare nel body
 * @returns {Promise} - Promise con la risposta
 */
export const apiPost = (endpoint, data = {}) => {
  const url = getNodeApiUrl(endpoint);
  return apiClient.post(url, data);
};

/**
 * Effettua una chiamata PUT a un endpoint API
 * @param {string} endpoint - Endpoint API (senza baseUrl)
 * @param {object} data - Dati da inviare nel body
 * @returns {Promise} - Promise con la risposta
 */
export const apiPut = (endpoint, data = {}) => {
  const url = getNodeApiUrl(endpoint);
  return apiClient.put(url, data);
};

/**
 * Effettua una chiamata DELETE a un endpoint API
 * @param {string} endpoint - Endpoint API (senza baseUrl)
 * @param {object} params - Parametri query string opzionali
 * @returns {Promise} - Promise con la risposta
 */
export const apiDelete = (endpoint, params = {}) => {
  const url = getNodeApiUrl(endpoint);
  return apiClient.delete(url, { params });
};

// Esporta direttamente l'istanza apiClient per casi d'uso avanzati
export default apiClient;
